<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-container fluid>
        <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                <v-card class="green lighten-5 pa-1">
                    <Title title="あなたのグループ">
                        <v-spacer />
                        <TitleButton
                            color="primary"
                            icon="mdi-plus-circle-outline"
                            name="追加"
                            @click="onClickAddGroup()" />
                    </Title>
                    <v-container v-if="groups != null && groups.length > 0" fluid>
                        <v-row>
                            <v-col v-for="group in groups" :key="group.groupNo" cols="12">
                                <v-card @click="selectedGroup = group" class="pa-1">
                                    <v-list-item>                                    
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{group.body.groupName}}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                        <TitleButton
                                            color="white"
                                            icon="mdi-pencil"
                                            name="編集"
                                            @click.native.stop="onClickEditGroup(group)" />
                                    </v-list-item>
                                    <v-expand-transition>
                                        <v-card-text v-if="group == selectedGroup" class="pa-0">
                                            <v-card class="ma-1 pa-1" outlined tile>
                                                <v-simple-table v-if="selectedGroup != null && selectedGroup.users.length > 0" dense>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-start ma-3" style="width:100%">ユーザー</th>
                                                            <th class="text-start">状態</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="user in group.users" >
                                                            <template v-if="user.body.userUID != user.body.ownerUserUID">
                                                                <v-menu offset-y absolute close-on-content-click min-width="100" max-width="300" :key="user.body.userUID">
                                                                    <template v-slot:activator="{ on }">
                                                                        <tr v-on="on">
                                                                            <td class="text-start" style="white-space:nowrap">
                                                                                <v-avatar class="ma-3" size="32" rounded>
                                                                                    <v-img v-if="user.userInfo.avaterURL == null" src="@/assets/no_avater_image.png"/>
                                                                                    <v-img v-if="user.userInfo.avaterURL != null" :src="user.userInfo.avaterURL"/>
                                                                                </v-avatar>
                                                                                {{user.userInfo.userName}}
                                                                            </td>
                                                                            <td class="text-start">{{userStateText(user.body)}}</td>
                                                                        </tr>
                                                                    </template>
                                                                    <v-list dense>
                                                                        <v-list-item @click="onSelectGroupUserHome(group, user)">
                                                                            <v-list-item-icon><v-icon>mdi-home-outline</v-icon></v-list-item-icon>
                                                                            <v-list-item-content>圃場管理</v-list-item-content>
                                                                        </v-list-item>
                                                                        <!-- <v-list-item disabled>
                                                                            <v-list-item-icon><v-icon>mdi-handshake-outline</v-icon></v-list-item-icon>
                                                                            <v-list-item-content>参加の再依頼</v-list-item-content>
                                                                        </v-list-item> -->
                                                                        <!-- <v-list-item @click="onSelectEditGroupUser(user)">
                                                                            <v-list-item-icon><v-icon>mdi-pencil-outline</v-icon></v-list-item-icon>
                                                                            <v-list-item-content>編集</v-list-item-content>
                                                                        </v-list-item> -->
                                                                        <v-list-item @click="onSelectedSendNotificationToGroupMember(group, user)">
                                                                            <v-list-item-icon><v-icon>mdi-send</v-icon></v-list-item-icon>
                                                                            <v-list-item-content>通知</v-list-item-content>
                                                                        </v-list-item>
                                                                    </v-list>
                                                                </v-menu>
                                                            </template>
                                                        </template>
                                                    </tbody>
                                                </v-simple-table>
                                                <div v-else style="background-color:yellow; padding:4px">このグループに参加しているユーザーがいません。<br/>メンバーの追加ボタンからメンバーを追加出来ます。</div>
                                            </v-card>
                                            <v-card class="ma-1" outlined tile>
                                                <div class="ma-2">
                                                    <v-btn color="primary" class="ma-1" @click="onClickAddMember">
                                                        <v-icon>mdi-plus-circle-outline</v-icon>メンバーの追加
                                                    </v-btn>
                                                    <v-btn v-if="group.users.length > 1" color="primary" class="ma-1" @click="onClickSendNotificationToGroupAllMembers(group)">
                                                        <v-icon>mdi-send</v-icon>全メンバーへの通知作成
                                                    </v-btn>
                                                </div>
                                            </v-card>                
                                        </v-card-text>
                                    </v-expand-transition>
                                </v-card>         
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-container v-else dense>
                        <v-row>
                            <v-col>グループは作成されていません。<br/><v-icon>mdi-plus-circle-outline</v-icon> で新しいグループを作成出来ます。</v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                <v-card class="green lighten-5 pa-1">
                    <Title title="所属" />
                    <div>
                        <v-container v-if="belongGroups != null && belongGroups.length > 0">
                            <v-row>
                                <v-col v-for="group in belongGroups" :key="group.body.ownerUserUID+group.body.groupNo" cols="12">
                                    <v-card @click="selectedBelongGroup = group" class="pa-1">
                                        <v-list-item>                                    
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <v-avatar class="ma-3" size="32" rounded>
                                                        <v-img v-if="group.ownerInfo.avaterURL == null" src="@/assets/no_avater_image.png"/>
                                                        <v-img v-if="group.ownerInfo.avaterURL != null" :src="group.ownerInfo.avaterURL"/>
                                                    </v-avatar>
                                                    {{group.ownerInfo.userName}} さんの {{group.group.groupName}}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-expand-transition>
                                            <v-card-text v-if="group == selectedBelongGroup" class="pa-0">
                                                <v-card class="ma-1 pa-1" outlined tile>
                                                    <v-simple-table v-if="group.users != null && group.users.length > 0" dense>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-start ma-3" style="width:100%">ユーザー</th>
                                                                <!-- <th></th> -->
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <template v-for="user in group.users">
                                                                <template v-if="user.body.userUID != userUID">
                                                                    <v-menu offset-y absolute close-on-content-click min-width="100" max-width="300" :key="user.body.userUID" >
                                                                        <template v-slot:activator="{ on }">
                                                                            <tr v-on="on">
                                                                                <td class="text-start" style="white-space:nowrap">
                                                                                    <v-avatar class="ma-3" size="24" rounded>
                                                                                        <v-img v-if="user.userInfo.avaterURL == null" src="@/assets/no_avater_image.png"/>
                                                                                        <v-img v-if="user.userInfo.avaterURL != null" :src="user.userInfo.avaterURL"/>
                                                                                    </v-avatar>
                                                                                    <span v-if="user.body.userUID == group.group.ownerUserUID">【所有者】</span>
                                                                                    {{user.userInfo.userName}}
                                                                                </td>
                                                                            </tr>
                                                                        </template>
                                                                        <v-list dense>
                                                                            <v-list-item @click="onSelectBelongGroupUserHome(group, user)">
                                                                                <v-list-item-icon><v-icon>mdi-home-outline</v-icon></v-list-item-icon>
                                                                                <v-list-item-content>圃場管理</v-list-item-content>
                                                                            </v-list-item>
                                                                            <v-list-item @click="onSelectedSendNotificationToBelongGroupMember(group, user)">
                                                                                <v-list-item-icon><v-icon>mdi-send</v-icon></v-list-item-icon>
                                                                                <v-list-item-content>通知</v-list-item-content>
                                                                            </v-list-item>
                                                                        </v-list>
                                                                    </v-menu>
                                                                </template>
                                                            </template>
                                                        </tbody>
                                                    </v-simple-table>
                                                </v-card>
                                                <v-card class="ma-1" outlined tile>
                                                    <div class="ma-2">
                                                        <!-- <v-btn color="warning" class="ma-1">
                                                            <v-icon>mdi-heart-broken</v-icon>このグループから抜ける
                                                        </v-btn> -->
                                                        <v-btn color="primary" class="ma-1" @click="onClickSendNotificationToBelongGroupAllMembers(group)">
                                                            <v-icon>mdi-send</v-icon>全メンバーへの通知作成
                                                        </v-btn>
                                                    </div>
                                                </v-card>                
                                            </v-card-text>
                                        </v-expand-transition>
                                    </v-card>         
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-container v-else>
                            <v-row>
                                <v-col>グループには所属していません。</v-col>
                            </v-row>
                        </v-container>
                    </div>
                </v-card>
            </v-col>
        </v-row>

        <GroupMaintenance ref="groupMaintenance" />
        <UserFinder ref="userFinder" @onSelectedUser="onSelectedUser" :excludeUserIDList="excludeUserIDList" />
        <UserMaintenance ref="userMaintenance" />
        <NotificationCreator ref="notificationCreator" />
        <v-snackbar v-model="notification.isView" :timeout=2000 :color="notification.color">{{notification.message}}</v-snackbar>
        <Confirm ref="confirm" />
    </v-container>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import GroupMaintenance from './MaintenanceGroup';
    import UserMaintenance from './MaintenanceGroupUser';
    import UserFinder from '@/components/tools/UserFinder';
    import Confirm from '@/components/tools/ConfirmDialog';
    import NotificationCreator from '@/components/notification/items/NotificationCreator';
    export default {
        components: {
            GroupMaintenance,
            UserMaintenance,
            UserFinder,
            NotificationCreator,
            Title,
            TitleButton,
            Confirm
        },
        computed: {
            userUID: function () {
                return this.$store.getters["loggedInUserUID"]
            },
            userData: function () {
                return this.$store.getters["loggedInUserData"]
            },
            /**
             * 所有する全グループ
             * {
             *      body: グループデータ,
             *      users: グループ所属の全ユーザー
             *      {
             *          body: ユーザーデータ,
             *          userInfo: {
             *              userName:
             *              avaterURL:
             *          }
             *      },
             * }
             */
            groups: function () {
                return this.$store.getters["managementItems/groups"]
            },
            /**
             * 所属する全グループ
             * {
             *      body: 所属グループデータ,
             *      group: グループデータ
             *      ownerInfo: { 所有者情報
             *          userName:
             *          avaterURL:
             *      }
             *      users: グループ所属の全ユーザー
             *      {
             *          body: ユーザーデータ,
             *          userInfo: {
             *              userName:
             *              avaterURL:
             *          }
             *      },
             * }
             */
            belongGroups: function () {
                return this.$store.getters["managementItems/belongGroups"]
            }
        },
        data: function () {
            return {
                selectedGroup:null,                 // 選択されたグループ
                selectedBelongGroup:null,           // 選択された所属グループ
                excludeUserIDList: [],              // ユーザー検索時に検索結果から除外するユーザーのユーザーIDが格納された配列
                notification: {
                    isView: false,
                    message: "",
                    color: "primary"
                },
            }
        },
        methods: {
            userStateText: function (user) {
                const index = this.$store.getters["groupMemberStates"].findIndex((v) => v.value === user.state)
                return this.$store.getters["groupMemberStates"][index].text
            },
            /**
             * グループ追加ボタン押下時
             */
            onClickAddGroup: function () {
                this.$refs.groupMaintenance.show(null)
            },
            /**
             * グループ編集ボタン押下時
             */
            onClickEditGroup: function (group) {
                this.$refs.groupMaintenance.show(group.body)
            },
            /**
             * グループユーザーの編集選択時
             */
            onSelectEditGroupUser: function (user) {
                console.log("onSelectEditGroupUser")
                this.$refs.userMaintenance.show(user)
            },
            /**
             * グループユーザーの圃場管理選択時(グループユーザーのホーム画面に移動)
             */
            onSelectGroupUserHome: function (group, user) {
                console.log("onSelectUserHome", group, user)
                // onSelectedGroupUserイベントを発行
                // HOME画面でそのイベントをハンドリングしているので、そこで共有処理を開始
                this.$emit("onSelectedGroupUser", {group: group, user:user})
            },
            /**
             * 所属グループのユーザーの圃場管理選択時(グループユーザーのホーム画面に移動)
             */
            onSelectBelongGroupUserHome: function (belongGroup, user) {
                console.log("onSelectBelongGroupUserHome", belongGroup, user)
                // onSelectedGroupUserイベントを発行
                // HOME画面でそのイベントをハンドリングしているので、そこで共有処理を開始
                this.$emit("onSelectedGroupUser", 
                {
                    group: {
                        body: belongGroup.group,
                        users: belongGroup.users
                    },
                    user: user
                })
            },
            /**
             * グループユーザー追加ボタン押下時
             */
            onClickAddMember: function () {
                this.excludeUserIDList = []
                for (var i=0; i<this.selectedGroup.users.length; i++) {
                    this.excludeUserIDList.push(this.selectedGroup.users[i].body.userUID)
                }
                this.$refs.userFinder.show()
            },
            /**
             * グループの全メンバーへの通知作成ボタン押下時
             */
            onClickSendNotificationToGroupAllMembers: function (group) {
                this.$refs.notificationCreator.show({
                    type: "group",
                    groups: [group.body.groupNo]
                })
            },
            /**
             * 所属グループの全メンバーへの通知作成ボタン押下時
             */
            onClickSendNotificationToBelongGroupAllMembers: function (group) {
                this.$refs.notificationCreator.show({
                    type: "belong_group",
                    groups: [
                        {
                            userUID: group.body.ownerUserUID,
                            groupNo: group.body.groupNo
                        }
                    ]
                })
            },
            /**
             * グループ内のメンバーへの通知選択時
             */
            onSelectedSendNotificationToGroupMember: function (group, user) {
                this.$refs.notificationCreator.show({
                    type: "group_member",
                    groupNo: group.body.groupNo,
                    users: [user.body.userUID]
                })
            },
            /**
             * 所属グループ内のメンバーへの通知選択時
             */
            onSelectedSendNotificationToBelongGroupMember: function (group, user) {
                this.$refs.notificationCreator.show({
                    type: "belong_group_member",
                    ownerUserUID: group.body.ownerUserUID,
                    groupNo: group.body.groupNo,
                    users: [user.body.userUID]
                })
            },
            // =====================================================================
            // 
            setGroupUsers: function (group) {
                console.log("setGroupUsers", group)
                const self = this
                group.users = []
                db.collection("users").doc(this.userUID)
                .collection("groups").doc(""+group.body.groupNo)
                .collection("users").orderBy("registeredDateTime", "asc").get().then(function(snapShot){
                    snapShot.forEach(function(doc){

                        var user = {
                            body: doc.data(),
                            userInfo: {
                                userName: "",
                                avaterURL: ""
                            }
                        }
                        self.mi_userData(user.body.userUID, user.userInfo)

                        group.users.push(user)
                    })
                }).catch (function(error){
                    console.log(error)
                    self.mi_writeLog("GroupManager/setGroupUsers", "exception("+error+")")
                })
            },
            // =====================================================================
            // ユーザー検索画面でユーザーが選択された時
            // user: {
            //     userUID:
            //     userData:
            // }
            onSelectedUser: function (user) {
                console.log("SelectorGroup", "onSelectedUser", user)

                const self = this
                this.$refs.confirm.show({
                    title: "グループ参加依頼",
                    message: user.userData.userName + "さんに、このグループへの参加を依頼しますか？",
                    width: 400,
                    buttonYes: "依頼する",
                    buttonNo: "依頼しない",
                    listenerYes: function () {
                        self.requestGroupJoint(user)
                        return true
                    },
                })
            },
            // =====================================================================
            // 所属グループの状態を更新する
            updateBelonginGroupState: function (group, state) {
                console.log("SelectorGroup", "updateBelonginGroupState", group, state)

                const currentDateTime = this.df_currentDateTime()
                const self = this
                
                var batch = db.batch()

                // 所属グループの状態更新
                var docBelongGroup = db.collection("users").doc(this.userUID).collection("belong_groups").doc(group.body.userUID+"-"+group.body.groupNo)
                batch.update(docBelongGroup, {"state":state, "updatedDateTime":currentDateTime})

                // グループ配下のユーザーの状態更新
                var docGroupUser = db.collection("users").doc(group.body.userUID).collection("groups").doc(""+group.body.groupNo).collection("users").doc(this.userUID)
                batch.update(docGroupUser, {"state":state, "updatedDateTime":currentDateTime})

                // コミット
                batch.commit().then(function(){
                    group.state = state
                    self.showNotification("所属の状態を更新しました。", false)
                }).catch(function(error){
                    console.log(error)
                    self.showNotification("所属の状態更新に失敗しました。", true)
                    self.mi_writeLog("GroupManager/updateBelonginGroupState", "exception("+error+")")
                })
            },
            // =====================================================================
            // グループへの参加依頼を行う
            requestGroupJoint: function (user) {

                const self = this
                const currentDateTime = this.df_currentDateTime()

                const groupUser = {
                    version: "2.0.0",
                    ownerUserUID: this.userUID,
                    groupNo: this.selectedGroup.body.groupNo,
                    userUID: user.userUID,
                    state: 10,
                    authorities: [
                        "place", 
                        "place.work.browse", 
                        "place.environment.browse", 
                    ],
                    registeredDateTime: currentDateTime,
                    updatedDateTime: ""
                }

                // 追加したユーザーにグループ参加依頼を通知
                var notificator = function () {
                    self.$store.commit("sendNotification", {
                        to: {                            
                            userUID: user.userUID,
                        },
                        sender: {
                            userUID: self.userUID,
                            userData: self.userData
                        },
                        content: {
                            type: 10,
                            title: "グループ参加依頼",
                            message: "グループ ["+self.selectedGroup.body.groupName + "] への参加をお願いします。"
                        },
                        data: {
                            groupNo: self.selectedGroup.body.groupNo,
                            groupName: self.selectedGroup.body.groupName,
                            answeredDateTime: ""
                        },
                        success: function () {
                            self.$store.commit("notification", {message:"グループへの参加依頼を送信しました。", isError:false})
                            userRegister()
                        },
                        failed: function (error) {
                            console.log(error)
                            self.$store.commit("notification", {message:"グループへの参加依頼の送信に失敗しました。", isError:true})
                        }
                    })
                }
                
                // グループユーザーを登録
                // (通知後)
                var userRegister = function () {
                    db.collection("users").doc(self.userUID)
                    .collection("groups").doc(""+self.selectedGroup.body.groupNo)
                    .collection("users").doc(user.userUID).set(groupUser).then(function(){
                        self.$store.commit("managementItems/addGroupUser", {group: self.selectedGroup, user: groupUser})
                        self.$refs.userFinder.close()
                    }).catch (function(error){
                        console.log(error)
                        self.mi_writeLog("GroupManager/requestGroupJoint/userRegister", "exception("+error+")")
                    })
                }

                // 通知処理
                notificator()
            },
            showNotification: function (message, isError){
                this.notification.message = message
                if (isError) {
                    this.notification.color = "error"
                } else {
                    this.notification.color = "primary"
                }
                this.notification.isView = true
            }
        }
    }
</script>
